import { g as __rest, b as __assign } from '../../../../tslib.es6-14c74580.js';
import React__default from 'react';

var InfoBlockInner = function (_a) {
    var children = _a.children, size = _a.size, forFreeBet = _a.forFreeBet, _b = _a.className, className = _b === void 0 ? '' : _b, rest = __rest(_a, ["children", "size", "forFreeBet", "className"]);
    return (React__default.createElement("div", __assign({ className: "inner-info-block-".concat(size, " ").concat(className, " ").concat(forFreeBet ? 'free-bet-icon' : '') }, rest), children));
};

export { InfoBlockInner };
